import { render, staticRenderFns } from "./MbSteps.vue?vue&type=template&id=5145af52&scoped=true&"
import script from "./MbSteps.vue?vue&type=script&lang=js&"
export * from "./MbSteps.vue?vue&type=script&lang=js&"
import style0 from "./MbSteps.vue?vue&type=style&index=0&id=5145af52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145af52",
  null
  
)

export default component.exports